module.exports = __webpack_public_path__ + "static/WAA_Full_Logo-db4c180a294207489a2be997899af876.webp";